import React from 'react';

const Footer = () => {

  return (
  <footer className="footer08">
    <div className="container">
      <div className="row">
        <div className="col-sm-6 col-md-3 col-lg-3">
          <div className="widget about-widget">
            <div className="widget-title">
              <img src="/images/logo_flacso_footer.png" alt="Flacso"/>
            </div>
          </div>
        </div>
        <div className="col-sm-6 col-md-3 col-lg-3">
          <div className="widget text-widget">
            <div className="widget-content">
              <ul className="list-unstyled">
                <li><i className="fa fa-envelope"></i> dbp@flacso.org.ar</li>
                <li><i className="fa fa-phone"></i> +(5411) 5238 9459</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="col-sm-6 col-md-3 col-lg-3">
          <div className="widget footer-social">
            <div className="widget-title">
              <h2>Seguinos en:</h2>
            </div>
            <div className="widget-content">
              <ul className="list-unstyled">
              <li><a href="https://www.linkedin.com/in/programa-de-derecho-y-bienes-p%C3%BAblicos-90a3b3161/"><i className="fa fa-linkedin"></i></a></li>
              <li><a href="https://www.instagram.com/dbpflacso/"><i className="fa fa-instagram"></i></a></li>
              </ul>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div className="footer-bottom footer-bottom08">
      <div className="container">
        <div className="footer-bottom-inner">
          <div className="row">
            <div className="col-md-6 col-sm-12">
            </div>
            <div className="col-md-6 col-sm-12">
              <p id="back-top"><a href="#top"><i className="fa fa-angle-up"></i></a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>

  );
}

export default Footer;
